 
(function () {
  'use strict';

  var HOOK = '[data-product-video-content]';
 
  function prepThemeBlockSlides(el) {
    var wrapper = el.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    Array.prototype.forEach.call(wrapper.children, function (child) {
      if (child.classList.contains('shopify-block')) child.classList.add('swiper-slide');
    });
  }

  function buildSwiper(el) {
    if (!el || el._pvSwiper) return;

    var slider = el.querySelector('.product-video-content__slider');
    if (!slider) return;

    prepThemeBlockSlides(el);

    var wrapper = slider.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    var slides = wrapper.querySelectorAll(':scope > .swiper-slide');
    if (!slides.length) return;

    var perView = parseFloat(el.dataset.slidesPerView) || 2;
    var gap = parseInt(el.dataset.spaceBetween, 10);
    if (isNaN(gap)) gap = 16;
    var speed = parseInt(el.dataset.autoplaySpeed, 10) || 0;
 
    var perMobile = 2;
    var perTablet = Math.min(2, perView);
    var perLaptop = Math.min(3, perView);
 
    var canLoop = el.dataset.loop === 'true' && slides.length > perView;

    var options = {
      slidesPerView: perMobile,
      spaceBetween: gap,
      loop: canLoop,
      a11y: { enabled: true },
      watchOverflow: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        0: { slidesPerView: perMobile, spaceBetween: gap },
        576: { slidesPerView: perTablet, spaceBetween: gap },
        992: { slidesPerView: perLaptop, spaceBetween: gap },
        1200: { slidesPerView: perView, spaceBetween: gap }
      }
    };

    var pagination = el.querySelector('[data-product-video-pagination]');
    if (pagination) {
      options.pagination = {
        el: pagination,
        clickable: true
      };
    }

    var prev = el.querySelector('.swiper-button-prev');
    var next = el.querySelector('.swiper-button-next');
    if (prev && next) {
      options.navigation = { prevEl: prev, nextEl: next };
    }

    if (speed > 0) {
      options.autoplay = {
        delay: speed * 1000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false
      };
    }

    el._pvSwiper = new window.Swiper(slider, options);
    el.classList.add('is-initialised');
  }

  function destroySwiper(el) {
    if (el && el._pvSwiper) {
      el._pvSwiper.destroy(true, true);
      el._pvSwiper = null;
      el.classList.remove('is-initialised');
    }
  }

  function syncToggle(btn, playing) {
    if (!btn) return;
    btn.classList.toggle('is-playing', playing);
    btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
    var label = playing ? btn.dataset.labelPause : btn.dataset.labelPlay;
    if (label) btn.setAttribute('aria-label', label);
  }

  function initPlayToggles(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-pv-play-toggle]').forEach(function (btn) {
      if (btn.dataset.pvToggleInit) return;

      var media = btn.closest('.product-video__media');
      var video = media ? media.querySelector('video') : null;
      if (!video) return;
      btn.dataset.pvToggleInit = '1';

      btn.addEventListener('click', function () {
        if (video.paused) {
          delete video.dataset.pvUserPaused;
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        } else {
          video.dataset.pvUserPaused = '1';
          video.pause();
        }
      });

      video.addEventListener('play', function () { syncToggle(btn, true); });
      video.addEventListener('pause', function () { syncToggle(btn, false); });
      video.addEventListener('ended', function () { syncToggle(btn, false); });

      syncToggle(btn, !video.paused);
    });
  }

  /* Pause offscreen videos so several autoplaying slides don't compete. */
  function initAutoplayInView(scope) {
    var root = scope || document;
    root.querySelectorAll(HOOK).forEach(function (el) {
      if (el._pvObserver) return;

      var videos = el.querySelectorAll('video[autoplay]');
      if (!videos.length) return;

      el._pvObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              if (video.dataset.pvUserPaused) return;
              var playing = video.play();
              if (playing && playing.catch) playing.catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.25 }
      );

      videos.forEach(function (video) {
        el._pvObserver.observe(video);
      });
    });
  }

  function destroyObservers(scope) {
    var root = scope || document;
    root.querySelectorAll(HOOK).forEach(function (el) {
      if (el._pvObserver) {
        el._pvObserver.disconnect();
        el._pvObserver = null;
      }
    });
  }

  function waitForSwiper(scope) {
    if (!window.Swiper) {
      window.requestAnimationFrame(function () {
        waitForSwiper(scope);
      });
      return;
    }
    var root = scope || document;
    root.querySelectorAll(HOOK).forEach(buildSwiper);
  }

  function init(scope) {
    waitForSwiper(scope);
    initAutoplayInView(scope);
    initPlayToggles(scope);
  }

  function teardown(scope) {
    var root = scope || document;
    root.querySelectorAll(HOOK).forEach(destroySwiper);
    destroyObservers(scope);
  }

  /* Only act when the event target actually contains one of our blocks —
     this is what lets the block work inside any host section. */
  function scopeFor(target) {
    if (!target || !target.querySelector) return null;
    return target.querySelector(HOOK) ? target : null;
  }

  if (!customElements.get('product-video-carousel')) {
    customElements.define('product-video-carousel', class extends HTMLElement {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var scope = scopeFor(e.target);
    if (!scope) return;
    teardown(scope);
    init(scope);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var scope = scopeFor(e.target);
    if (scope) teardown(scope);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target.closest(HOOK) || scopeFor(e.target);
    if (!el) return;
    var carousel = el.matches && el.matches(HOOK) ? el : el.querySelector(HOOK);
    if (carousel && carousel._pvSwiper) carousel._pvSwiper.update();
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var el = e.target.closest(HOOK);
    if (el && el._pvSwiper) el._pvSwiper.update();
  });
})();
